// eslint-disable-next-line import/prefer-default-export
export async function blobToBase64Raw(blob: Blob) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onerror = reject;
		reader.onload = () => {
			// Extract only the Base64 part after the comma
			const base64data = (reader.result as string)?.split(',')[1] || '';
			resolve(base64data);
		};
		reader.readAsDataURL(blob);
	});
}

async function dataURLToBlob(dataURL: string) {
	const response = await fetch(dataURL);
	const blob = await response.blob();
	return blob;
}

export async function base64ToBlob(base64: string, mimeType: string) {
	const dataURL = `data:${mimeType};base64,${base64}`;
	return dataURLToBlob(dataURL);
}

export function bufferToBlob(buffer: Buffer, mimeType: string) {
	const blob = new Blob([buffer as any], { type: mimeType });
	return blob;
}
